<app-modal-header>
  @if (!isEdit) {
    <div class="flex text-lg font-semibold" translate>trilhas.estudio.trilha.novo-elemento</div>
  } @else {
    <div class="flex text-lg font-semibold">
      {{ !!form.value.titulo && form.value.titulo !== '' ? form.value.titulo : ('geral.titulo' | translate) }}
    </div>
  }
</app-modal-header>
<form [formGroup]="form" (submit)="onSubmit()">
  <div app-modal-content class="h-[75vh] w-screen overflow-y-auto p-2! md:w-[70vw]">
    @if (!isEdit) {
      <ul class="flex items-center justify-center">
        @for (type of types; track $index) {
          <li>
            @if (type.style.display !== 'hidden') {
              <button
                type="button"
                class="group/tipos duration-300 flex gap-2 w-full lg:w-[8rem] items-center justify-center whitespace-nowrap rounded-t-2xl p-2 {{
                  type.style.hover
                }}"
                (click)="onChangeType(type.type)"
                [ngClass]="type.type === form.value.tipo ? [type.style.bg, 'active'] : 'bg-theme-50'"
                [disabled]="isEdit"
              >
                <svg-icon
                  src="assets/icons/icon-{{ type.file }}.svg"
                  class="flex max-h-6 min-w-9 w-9 duration-300 group-hover/tipos:text-white"
                  [ngClass]="type.type === form.value.tipo ? 'text-white' : type.style.text"
                >
                </svg-icon>
                <span
                  class="hidden truncate font-semibold duration-300 group-hover/tipos:text-white lg:block"
                  [ngClass]="type.type === form.value.tipo ? 'text-white' : type.style.text"
                >
                  {{ type.title }}
                </span>
              </button>
            }
          </li>
        }
      </ul>
    } @else {
      <div class="flex items-center justify-center">
        @let type = currentType;
        <div
          class="group/tipos flex gap-2 items-center justify-center w-full mx-8 p-2 whitespace-nowrap rounded-t-2xl {{
            type.style.bg
          }}"
        >
          <svg-icon
            src="assets/icons/icon-{{ type.file }}.svg"
            class="flex max-h-6 w-9 text-white group-hover/tipos:text-white"
          >
          </svg-icon>
          <span class="font-semibold text-white">
            {{ type.title }}
          </span>
        </div>
      </div>
    }
    <div
      class="mx-0 mb-8 rounded-b-xl border-x-2 border-b-4 p-8 md:mx-8"
      [ngClass]="
        !!currentType ? [currentType.style.border, !isEdit ? 'rounded-t-xl border-t-4' : ''] : 'border-theme-500'
      "
    >
      <div>
        <div class="flex flex-row justify-between gap-4">
          @if (form.value.tipo !== 'avaliacao') {
            <app-form-field class="w-full">
              <label class="text-[14px]!" app-label translate>geral.titulo</label>
              <input app-input formControlName="titulo" maxLength="120" [placeholder]="'geral.titulo' | translate" />
            </app-form-field>
          }
        </div>

        @switch (form.value.tipo) {
          @case ('video') {
            <app-upload-video-element
              formControlName="anexo_principal"
              [submitted]="submitted$ | async"
            ></app-upload-video-element>
          }
          @case ('audio') {
            <app-upload-audio-element
              formControlName="anexo_principal"
              [submitted]="submitted$ | async"
            ></app-upload-audio-element>
          }
          @case ('flip') {
            <app-upload-flip-element
              formControlName="anexo_principal"
              [submitted]="submitted$ | async"
            ></app-upload-flip-element>
          }
          @case ('imagem') {
            <app-upload-image-element
              formControlName="anexo_principal"
              [submitted]="submitted$ | async"
            ></app-upload-image-element>
          }
          @case ('link') {
            <div class="flex flex-col gap-3 md:flex-row">
              <app-upload-link-element
                class="w-full"
                formControlName="anexo_principal"
                [submitted]="submitted$ | async"
              ></app-upload-link-element>
              @if (form.value.tipo === 'link') {
                <div class="flex flex-col pb-6">
                  <label app-label class="min-w-max text-[14px]!" translate>trilhas.estudio.abrir-iframe</label>
                  <app-switch colorTrue="bg-base-trilhas-tipo-link" formControlName="iframe"></app-switch>
                </div>
              }
            </div>
          }
        }

        @if (form.value.tipo !== 'avaliacao') {
          <app-form-field>
            <label class="text-[14px]!" app-label translate>trilhas.estudio.trilha.conteudo</label>
            <app-text-editor formControlName="conteudo" [url]="ckeditorUploadImageUrl"></app-text-editor>
          </app-form-field>

          <app-form-field>
            <label class="text-[14px]!" app-label translate>trilhas.estudio.trilha.anexos</label>
            @if (form.value.anexos?.length < 10) {
              <app-upload-file [config]="configUpload" (statusChange)="onUpload($event)"></app-upload-file>
            }
          </app-form-field>

          @if (!!form.value.anexos?.length) {
            <div class="self-stretch">
              <table app-table class="w-full border-collapse">
                <thead>
                  <th app-table-cell class="sticky text-left" translate>trilhas.estudio.trilha.arquivo</th>
                  <th app-table-cell class="sticky" translate>geral.acoes</th>
                </thead>
                <tbody app-table-body class="text-center">
                  @for (attachment of form.value.anexos; track attachment.id; let index = $index) {
                    <tr>
                      <td app-table-cell class="text-left">{{ attachment.nome_arquivo }}</td>
                      <td app-table-cell class="gap-4 align-middle">
                        <button
                          type="button"
                          app-flat-button
                          app-tooltip
                          [tooltip]="'geral.visualizar' | translate"
                          (click)="onOpenPreviewDoc(attachment)"
                        >
                          <svg-icon src="assets/icons/icon-view.svg" class="flex h-5 w-5 text-base-status-info-400">
                          </svg-icon>
                        </button>
                        <button
                          type="button"
                          app-flat-button
                          app-tooltip
                          [tooltip]="'geral.download' | translate"
                          (click)="onDownload(attachment)"
                        >
                          <svg-icon src="assets/icons/icon-download.svg" class="h-5 w-5 text-base-status-success-500">
                          </svg-icon>
                        </button>
                        <button
                          type="button"
                          app-flat-button
                          app-tooltip
                          [tooltip]="'geral.excluir' | translate"
                          (click)="onDelete(index)"
                        >
                          <svg-icon src="assets/icons/icon-trash.svg" class="h-5 w-5 text-base-status-danger">
                          </svg-icon>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        } @else {
          <app-card class="mx-1">
            <div
              app-card-content
              class="relative z-10 flex flex-col justify-between gap-4 rounded-xl! bg-[#f3f3f3]! py-3! md:flex-row"
            >
              <div class="flex flex-row items-center gap-2 truncate">
                <div>
                  <div
                    class="flex h-14 w-14 flex-col items-center justify-center rounded-full bg-base-gray-light-500 shadow-inner shadow-base-gray-200"
                  >
                    <svg-icon class="w-6 text-theme-500" src="assets/icons/icon-quiz-types.svg"></svg-icon>
                  </div>
                </div>
                <div class="flex items-center gap-1">
                  <div class="flex items-center justify-center gap-2">
                    <h1 class="select-none text-md font-medium normal-case">{{ form.value.titulo }}</h1>
                  </div>
                </div>
              </div>
              <div
                class="flex items-center justify-center gap-3 border-t-2 pt-4 md:justify-normal md:border-t-0 md:pt-0"
              >
                <div class="flex h-full items-center border-r border-theme-300 pr-10"></div>
                <button
                  app-tooltip
                  type="button"
                  [tooltip]="'geral.editar' | translate"
                  (click)="onOpenQuiz()"
                  class="p-1 md:mr-1"
                >
                  <svg-icon
                    class="flex w-7 text-theme-500 hover:text-theme-950"
                    src="assets/icons/icon-pencil.svg"
                  ></svg-icon>
                </button>
                <button
                  app-tooltip
                  type="button"
                  [tooltip]="'geral.visualizar' | translate"
                  (click)="onOpenPreviewQuiz(form.value.quiz_uuid)"
                  class="p-1 md:mr-1"
                >
                  <svg-icon
                    class="flex w-7 text-theme-500 hover:text-theme-950"
                    src="assets/icons/icon-eyes.svg"
                  ></svg-icon>
                </button>
              </div>
            </div>
            <div
              class="absolute -left-1 top-0 -z-10 h-full w-4 rounded-l-lg border-base-trilhas-tipo-quiz bg-base-trilhas-tipo-quiz"
            ></div>
          </app-card>
        }
      </div>
    </div>
  </div>
  <div app-modal-footer>
    <div class="flex w-full items-center justify-between gap-3">
      <button
        app-outline-button
        class="h-10! w-48! border-base-status-danger text-base-status-danger hover:[&:not([disabled])]:bg-base-status-danger hover:[&:not([disabled])]:text-theme-contrast"
        type="button"
        (click)="onClose()"
      >
        <span class="font-medium uppercase" translate>geral.cancelar</span>
      </button>
      <div class="flex items-center justify-end gap-4">
        <div class="flex items-center justify-start align-middle">
          <span [ngClass]="{ 'text-theme-500': showPublish() }" class="px-2 text-theme-950" translate
            >trilhas.estudio.trilha.publicar</span
          >
          @if (showPublish()) {
            <svg-icon
              class="flex mr-2 h-4! w-4! cursor-pointer text-gray-500!"
              app-tooltip
              [tooltip]="'trilhas.estado-elemento' | translate"
              src="assets/icons/icon-interrogation.svg"
            ></svg-icon>
          }
          <app-switch formControlName="addHistoricoEvento"> </app-switch>
        </div>
        <button
          app-outline-button
          class="w-48 border-theme-500 text-theme-500 hover:[&:not([disabled])]:bg-theme-500 hover:[&:not([disabled])]:text-theme-contrast"
          type="submit"
          [disabled]="loading()"
        >
          <span class="font-medium uppercase" translate>geral.salvar</span>
          @if (loading()) {
            <div class="flex ml-4 h-1 w-1">
              <app-skeleton baseStyle="bg-theme-500"></app-skeleton>
            </div>
          }
        </button>
      </div>
    </div>
  </div>
</form>
